import { Alert, Button } from "flowbite-react";
import { CircleAlert } from "lucide-react";
import { LEGAL_COMPLIANCE_COPY } from "@/features/legal/config/legal.config";

type LegalComplianceLoadErrorProps = {
  onRetry: () => void
  onLogout: () => void
};

export const LegalComplianceLoadError = ({ onRetry, onLogout }: LegalComplianceLoadErrorProps) => (
  <div className="space-y-6">
    <Alert color="lighterror" icon={CircleAlert}>
      {LEGAL_COMPLIANCE_COPY.LOAD_ERROR}
    </Alert>
    <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
      <Button color="light" onClick={onLogout} data-testid="legal-compliance-logout-button">
        {LEGAL_COMPLIANCE_COPY.LOGOUT}
      </Button>
      <Button color="primary" onClick={onRetry} data-testid="legal-compliance-retry-button">
        {LEGAL_COMPLIANCE_COPY.RETRY}
      </Button>
    </div>
  </div>
);
